import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import {
  FETCH_INVOICE_PREFIXES,
  FETCH_INVOICE_PREFIX,
  CREATE_INVOICE_PREFIX,
  UPDATE_INVOICE_PREFIX,
  DELETE_INVOICE_PREFIX,
} from "../../urls";

class InvoicePrefixesService {
  getInvoicePrefixes = async (page = 1, perPage = 20, isActive = null, search = "", sortBy = "id", order = "DESC") => {
    try {
      const response = await apiBase.get(FETCH_INVOICE_PREFIXES(page, perPage, isActive, search, sortBy, order));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching invoice prefixes");
    }
  };

  getInvoicePrefix = async (id) => {
    try {
      const response = await apiBase.get(FETCH_INVOICE_PREFIX(id));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching invoice prefix");
    }
  };

  createInvoicePrefix = async (prefixData) => {
    try {
      const response = await apiBase.post(CREATE_INVOICE_PREFIX, prefixData);
      if (response.status !== 200 && response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating invoice prefix");
    }
  };

  updateInvoicePrefix = async (id, prefixData) => {
    try {
      const response = await apiBase.put(UPDATE_INVOICE_PREFIX(id), prefixData);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating invoice prefix");
    }
  };

  deleteInvoicePrefix = async (id) => {
    try {
      const response = await apiBase.delete(DELETE_INVOICE_PREFIX(id));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting invoice prefix");
    }
  };
}

export default new InvoicePrefixesService();

